import React from 'react';
import Section from '../Section/section';
import FeatureToggle from '../FeatureToggle/feature.toggle';

export const DeclinePage = ({ focusableRef }) => {
  return (
    <Section className="decline">
      <FeatureToggle featureName="new_error_message_for_decline_pages">
        <h2 ref={focusableRef} tabIndex="-1">Sorry, but we’re unable to approve your application for a<br/>
        Barclays Personal Loan at this time.</h2>
        <p>You will receive additional information about your application request, in the mail, within 7-10 business days.</p>
      </FeatureToggle>
      <FeatureToggle featureName="new_error_message_for_decline_pages" showWhenFeatureToggleOff={true}>
        <h2 ref={focusableRef} tabIndex="-1">Sorry, but we’re unable to approve your application for a Barclays Personal Loan at this time.</h2>
        <p>Questions?</p>
        <p>Call <a className="phone" href="tel:18774373342">877-437-3342</a></p>
        <p>Monday – Friday, 8 am to 8 pm</p>
        <p>Saturday, 9 am to 6:30 pm<br/>Eastern Time</p>
      </FeatureToggle>

    </Section>
  );
};

export default DeclinePage;

